const button = document.getElementById('navToggle');
const buttonIcon = document.getElementById('navToggleIcon');
const iconMenu = document.getElementById('menuOpen');
const iconClose = document.getElementById('menuClose');
const nav = document.getElementById('nav');
let initialWindowWidth = document.documentElement.clientWidth;
let mobileMenu = initialWindowWidth < 990;

if (nav) {
  button.addEventListener('click', () => {
    nav.style.display = nav.style.display === 'block' ? 'none' : 'block';

    if (nav.style.display === 'block') {
      iconMenu.style.display = 'none';
      iconClose.style.display = 'block';
    } else {
      iconMenu.style.display = 'block';
      iconClose.style.display = 'none';
    }
  });

  window.addEventListener('resize', () => {
    let currentWindowWidth = document.documentElement.clientWidth;

    if (currentWindowWidth !== initialWindowWidth) {
      if (window.innerWidth >= 990) {
        if (mobileMenu) {
          nav.style.display = 'block';
          iconMenu.style.display = 'none';
          iconClose.style.display = 'none';
          mobileMenu = false;
        }
      } else {
        if (!mobileMenu) {
          nav.style.display = 'none';
          iconMenu.style.display = 'block';
          iconClose.style.display = 'none';
          mobileMenu = true;
        }
      }
      initialWindowWidth = currentWindowWidth;
    }
  });
}
